export default __webpack_public_path__ + "static/media/filter_icon_meeting_room_blue.dd539bb0.svg";